import { callAPI, HTTPMethod } from "./API";
import { RegisteredProvidersCardsResponse, RegisteredProvidersGridResponse, UnregisteredIssuersCardsResponse, UnregisteredIssuersGridResponse, UnloadedInvoicesFilterRequest } from "../model/CfdisNonIntegrated";
import { 
    IssuerDetailsResponse, 
    IssuerDetailsFilterRequest,
    IssuerDetailsFilterAPIRequest,
    NonIntegratedCfdiFiles 
} from "../model/CfdisNonIntegrated";

export const getRegisteredProvidersCards = async (
    tenantId: string, 
    filters: UnloadedInvoicesFilterRequest
): Promise<RegisteredProvidersCardsResponse> => {
    
    const formatDate = (date: Date): string => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const params = new URLSearchParams({
        paymentMethod: filters.paymentMethod,
        startDate: formatDate(filters.startDate),
        endDate: formatDate(filters.endDate)
    });

    return await callAPI(`/tenants/${tenantId}/non-integrated-cfdis/registered-providers-cards?${params}`, {
        method: HTTPMethod.GET 
    });
};

export const getRegisteredProvidersGrid = async (
    tenantId: string,
    filters: UnloadedInvoicesFilterRequest,
    page: number = 0,
    pageSize: number = 20
): Promise<RegisteredProvidersGridResponse> => {
    
    const formatDate = (date: Date): string => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    
    const params = new URLSearchParams({
        paymentMethod: filters.paymentMethod,
        startDate: formatDate(filters.startDate),
        endDate: formatDate(filters.endDate),
        page: page.toString(),
        pageSize: pageSize.toString()
    });
    
    return await callAPI(`/tenants/${tenantId}/non-integrated-cfdis/registered-providers-grid?${params}`, {
        method: HTTPMethod.GET
    });
};

export const getUnregisteredIssuersCards = async (
    tenantId: string, 
    filters: UnloadedInvoicesFilterRequest
): Promise<UnregisteredIssuersCardsResponse> => {
    
    const formatDate = (date: Date): string => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const params = new URLSearchParams({
        paymentMethod: filters.paymentMethod,
        startDate: formatDate(filters.startDate),
        endDate: formatDate(filters.endDate)
    });

    return await callAPI(`/tenants/${tenantId}/non-integrated-cfdis/unregistered-issuers-cards?${params}`, {
        method: HTTPMethod.GET
    });
};


export const getUnregisteredIssuersGrid = async (
    tenantId: string,
    filters: UnloadedInvoicesFilterRequest,
    page: number = 0,
    pageSize: number = 20
): Promise<UnregisteredIssuersGridResponse> => {
    
    const formatDate = (date: Date): string => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    
    const params = new URLSearchParams({
        paymentMethod: filters.paymentMethod,
        startDate: formatDate(filters.startDate),
        endDate: formatDate(filters.endDate),
        page: page.toString(),
        pageSize: pageSize.toString()
    });
    
    return await callAPI(`/tenants/${tenantId}/non-integrated-cfdis/unregistered-issuers-grid?${params}`, {
        method: HTTPMethod.GET
    });
};

export async function getNonIntegratedFiles(
  tenantId: string,
  uuid: string
): Promise<NonIntegratedCfdiFiles> {
  return await callAPI(
    `/tenants/${tenantId}/non-integrated-cfdis/get-files/${uuid}`,
    {
      method: HTTPMethod.GET,
    }
  );
}

export async function deleteNonIntegrated(tenantId: string, uuid: string): Promise<void> {
    return await callAPI(`/tenants/${tenantId}/non-integrated-cfdis/delete-non-related-cfdi/${uuid}`, {
        method: HTTPMethod.DELETE
    });
}

export async function getIssuerDetails(
    tenantId: string, 
    issuerRfc: string,
    filters: IssuerDetailsFilterRequest
): Promise<IssuerDetailsResponse> {
    
    const formatDate = (date: Date): string => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const params = new URLSearchParams({
        paymentMethod: filters.paymentMethod,    
        startDate: formatDate(filters.startDate), 
        endDate: formatDate(filters.endDate),    
        page: (filters.page || 0).toString(),  
        pageSize: (filters.pageSize || 20).toString() 
    });

    return await callAPI(`/tenants/${tenantId}/non-integrated-cfdis/issuer-details/${encodeURIComponent(issuerRfc)}?${params}`, {
        method: HTTPMethod.GET 
    });
}